import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../components/toaster/Toaster";
import PurchaseInvoiceServices from "../../services/PurchaseInvoice";
import { deleteAlert } from "../components/sweetAlert";
import { Debounce, getDate } from "../../utils";
import { all_routes } from "../../Router/all_routes";

const Purchases = () => {

  const routes = all_routes;

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Purchase Invoices
  const [purchaseInvoices, setPurchaseInvoices] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filter
  const [filters, setFilters] = useState({});

  // *For Handle Filter
  const handleFilter = (data) => {
    Debounce(() => getPurchaseInvoices(1, '', data));
  }

  // *For Get Purchase Invoices
  const getPurchaseInvoices = async (page, limit, filter) => {
    setLoader(true)
    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      const Filter = { ...filters, ...filter }
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      let params = {
        page: Page,
        limit: Limit
      }
      params = { ...params, ...Filter }
      const { data, total_count } = await PurchaseInvoiceServices.getPurchaseInvoices(params)
      // setPurchaseInvoices([{
      //   recordId: '03413022501',
      //   invoiceNumber: 'INV-0001',
      //   invoice_date: '2023-01-01',
      //   invoice_due_date: '2023-01-01',
      //   supplier: 'John Doe',
      //   description: 'Lorem ipsum dolor sit amet, consectetur',
      //   invoiceTotal: '$100.00'
      // }])
      setPurchaseInvoices(data)
      setTotalCount(total_count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete Purchase Invoice
  const deletePurchaseInvoice = async (id) => {
    try {
      const isConfirmed = await deleteAlert()

      if (isConfirmed) {
        await PurchaseInvoiceServices.deletePurchaseInvoice(id);
        getPurchaseInvoices();

        Swal.fire({
          title: "Deleted!",
          text: "Purchase invoice has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.close();
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const columns = [
    {
      title: "Invoice #",
      dataIndex: "invoice",
      render: (text) => (
        <span>
          {text?.invoiceNumber}
        </span>
      ),
    },
    {
      title: "Invoice Date",
      dataIndex: "created_at",
      render: (text) => (
        <span>
          {getDate(text)}
        </span>
      ),
    },
    {
      title: "Invoice Due Date",
      dataIndex: "dueDate",
      render: (text) => (
        <span>
          {getDate(text)}
        </span>
      ),
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Reference",
      dataIndex: "invoiceReference",
    },
    {
      title: "Invoice Total",
      dataIndex: "totalAmount",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="text-center">
          <Link className="action-set" to="#" data-bs-toggle="dropdown" aria-expanded="true">
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link to={``} state={record} className="dropdown-item"><i data-feather="eye" className="feather-eye me-2"></i>View Invoice</Link>
            </li>
            <li>
              <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#edit-saleInvoices-new"><i data-feather="edit" className="feather-edit me-2"></i>Edit Purchase</Link>
            </li>
            {/* <li>
               <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#showpayment"><i data-feather="dollar-sign" className="feather-dollar-sign"></i>Show Payments</Link>
             </li> */}
            {/* <li>
               <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#createpayment"><i data-feather="plus-circle" className="feather-plus-circle me-2"></i>Create Payment</Link>
             </li> */}
            {/* <li>
               <Link to="#" className="dropdown-item"><i data-feather="download" className="feather-edit me-2"></i>Download pdf</Link>
             </li> */}
            <li>
              <Link to="#" className="dropdown-item confirm-text mb-0" onClick={() => deleteBay(record?.id)}><i data-feather="trash-2" className="feather-trash me-2"  ></i>Delete Purchase</Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getPurchaseInvoices()
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchase Invoice</h4>
                <h6>Manage Your Purchase Invoices</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to={routes?.createPurchase}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Purchase Invoice
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handleFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={purchaseInvoices}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => getPurchaseInvoices(page, pageSize)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Purchases;
